import RestApiModel from "@/api/Model/RestApiModel";

class DashboardData extends RestApiModel {
  static getResourceEndpoint() {
    return '/DashboardData';
  }
}

export default DashboardData;
